/** Base route for the sample medical practice demonstrations. */
export const practiceRoute = '/practice';

/**
 * Routes for the sample hosting demonstrations.
 */
export const PracticeRoutes = {
  /** Landing page for medical practice demonstration. */
  HOME: `${practiceRoute}`,
  /** Simulated calendar for practice / practitioner. */
  CALENAR: `${practiceRoute}/calendar`,
  /** Individual client appointment view. */
  APPOINTMENT: `${practiceRoute}/appointment/:clientId`,
  /** Access to a specific critique, without handoff. */
  INSTANCE: `${practiceRoute}/instance/:instanceId`
};
